"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavActions = void 0;
var react_1 = __importDefault(require("react"));
var NavActions_style_1 = __importDefault(require("./NavActions.style"));
exports.NavActions = function (_a) {
    var actions = _a.actions, selected = _a.selected, onUnselectAll = _a.onUnselectAll;
    return (react_1.default.createElement(NavActions_style_1.default, null,
        react_1.default.createElement("div", { className: "nav-actions", "data-cy": "nav-actions" },
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("td", { className: "deselect", onClick: onUnselectAll, "data-cy": "deselect", "data-testid": "deselect" },
                            react_1.default.createElement("i", { className: "far fa-minus-square" })),
                        react_1.default.createElement("td", { className: "count-items", "data-cy": "items-count" }, selected),
                        react_1.default.createElement("td", { className: "actions" }, actions &&
                            actions.map(function (i) { return (react_1.default.createElement("div", { className: "header-icon", key: i.id, "data-cy": "action-" + i.id, onClick: i.onPress }, i.item)); }))))))));
};
//# sourceMappingURL=NavActions.js.map